var _g, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUnreadMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 116 116",
    style: {
      enableBackground: "new 0 0 116 116"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M99.6,52.6c-2.4,0.6-4.2,0.9-5.8,0.9h-1.5v18.4c0,2.8-1.1,5.3-3.1,7.3s-4.5,3.1-7.3,3.1H49.8c-1.3,0-2.4,0.5-3.2,1.3 l-19.7,16.9l0.9-13.4c0.1-2.5-1.7-4.6-4.3-4.8h-3.7c-2.8,0-5.3-1.1-7.3-3.1c-1.9-1.9-3.1-4.6-3.1-7.3v-40c0-2.8,1.1-5.3,3.1-7.3 c2-2,4.5-3.1,7.3-3.1h42.6l0.1-1.4c0.2-1.7,0.6-3.4,1.4-5.6l0.7-2H19.9c-5.2,0-10.1,2-13.8,5.7c-3.6,3.6-5.6,8.6-5.6,13.7v40 c0,5.2,2,10.1,5.7,13.8C9.6,89,14,91,18.6,91.4l-1.3,19.3c-0.1,1.1,0.2,2.2,1,3.3l0.1,0.1c0.8,0.9,1.9,1.5,3.1,1.6 c0.1,0,0.2,0,0.3,0c1.1,0,2.1-0.4,3-1.1l26.8-23H82c5.2,0,10.1-2,13.8-5.7c3.7-3.7,5.7-8.6,5.7-13.8V52.2L99.6,52.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3,61.6c0,2.5,2,4.5,4.5,4.5h44.9c2.5,0,4.5-2,4.5-4.5c0-2.4-2.1-4.5-4.5-4.5H28.8C26.3,57.1,24.3,59.1,24.3,61.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4,42H28.8c-2.5,0-4.5,2-4.5,4.5s2,4.5,4.5,4.5h31.6c2.5,0,4.5-2,4.5-4.5S62.9,42,60.4,42z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 92.5,
    cy: 23.5,
    r: 22.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnreadMessage);
export default __webpack_public_path__ + "static/media/icon-unread-message.d9dae4d00591935fa7ffc4f2c5039739.svg";
export { ForwardRef as ReactComponent };